/* the one modal to rule them all */

import React, { FC } from 'react';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonModal,
  IonRow,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { close } from 'ionicons/icons';
import { DqText } from '../../dq-text';
import { useBreakpoint } from 'src/utils/helpers/platformHelpers';

export type AppModalActionButton = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
};
export type AppModalProps = {
  isOpen: boolean;
  title: string;
  onClose?: () => void;
  children: React.ReactNode;
  primaryButton?: AppModalActionButton;
  secondaryButton?: AppModalActionButton;
  className?: string;
  /**
   *  Breakpoints for mobile sheet
   * @see https://ionicframework.com/docs/api/modal#sheet-modal
   * */
  mobileSheetBreakpoints?: number[];
  /**
   * Initial height of the modal for mobile sheet
   *
   * @see https://ionicframework.com/docs/api/modal#sheet-modal
   */
  mobileSheetInitialBreakpoint?: number;
  /**
   * Content to be displayed in the footer above the action buttons
   */
  footerContent?: React.ReactNode;
};

export const AppModal: FC<AppModalProps> = props => {
  const isMd = useBreakpoint('md');

  return (
    <IonModal isOpen={props.isOpen} onDidDismiss={props.onClose} className={props.className}>
      {isMd ? (
        <IonRow className="ion-justify-content-between ion-align-items-center ion-padding">
          <DqText color="medium" variant="h1">
            {props.title}
          </DqText>
          <IonButton onClick={props.onClose} fill="clear" color="dark">
            <IonIcon icon={close} />
          </IonButton>
        </IonRow>
      ) : (
        <IonHeader>
          <IonToolbar>
            <IonTitle>{props.title}</IonTitle>
            {!!props.onClose && (
              <IonButton slot="end" fill="clear" color="dark" onClick={props.onClose}>
                <IonIcon color="dark" icon={close} />
              </IonButton>
            )}
          </IonToolbar>
        </IonHeader>
      )}
      <IonContent>{props.children}</IonContent>
      <IonFooter>
        {props.footerContent}
        <IonToolbar>
          {props.primaryButton && (
            <IonButton
              onClick={props.primaryButton.onClick}
              fill="solid"
              color="primary"
              expand="block"
              slot={isMd ? 'end' : ''}
              disabled={props.primaryButton.disabled}
            >
              {props.primaryButton.label}
            </IonButton>
          )}
          {props.secondaryButton && (
            <IonButton
              onClick={props.secondaryButton.onClick}
              fill="clear"
              color="dark"
              expand={isMd ? undefined : 'block'}
              slot={isMd ? 'end' : ''}
              disabled={props.secondaryButton.disabled}
            >
              {props.secondaryButton.label}
            </IonButton>
          )}
        </IonToolbar>
      </IonFooter>
    </IonModal>
  );
};
